import { sidenavTokens } from './tokens';

interface resolveNestingPaddingProps {
  nestingLevel?: 0 | 1 | 2;
  type?: 'item' | 'group';
}

/**
 * Determine left padding for a given nesting level and Nav item type
 */
export const resolveNestingPadding = ({ nestingLevel = 0, type = 'item' }: resolveNestingPaddingProps) => {
  let padding: string;
  let defaultValue: string;

  if (type === 'item') {
    padding = sidenavTokens[`ItemPaddingLeftLevel${nestingLevel}`];
    defaultValue = sidenavTokens.ItemPaddingLeftLevel0;
  } else {
    padding = sidenavTokens[`GroupItemPaddingLeftLevel${nestingLevel}`];
    defaultValue = sidenavTokens.GroupItemPaddingLeftLevel0;
  }

  return padding ?? defaultValue;
};
